import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserUtils from "../../util/UserUtils";
import { UserRole, hasRole } from "../../util/roles";

export function useUserPermissions(loggedIn, accounts) {
  const [permissions, setPermissions] = useState({
    rules: false,
    cashSales: false,
    reports: false,
    users: false,
    clients: false,
    payments: false,
    settings: false
  });
  const [userInfo, setUserInfo] = useState({
    email: "",
    name: ""
  });
  const navigate = useNavigate();

  const loadUser = () => {
    UserUtils.getUserData((data) => {
      if (data) {
        setUserInfo({
          email: data.emailAddress,
          name: data.name
        });
        setPermissions({
          cashSales: hasRole(data.roles || [], UserRole.Admin, UserRole.NagcoMaintainer, UserRole.NagcoView, UserRole.NagcoReceiptUnder5000, UserRole.NagcoReceiptAll),
          reports: hasRole(data.roles || [], UserRole.Admin, UserRole.ReportsAll),
        });
      } else {
        navigate("/");
      }
    });
  };

  useEffect(() => {
    if (loggedIn) {
      loadUser();
    }
  }, [loggedIn, accounts]);

  return { permissions, userInfo };
}
